<div class="d-flex mt-2">
    <input id="customSwitches{{sequence}}"  type="checkbox" switch="bool" 
     [(ngModel)]="isEnabled" [checked]="isEnabled" (change)="onChange($event)">
     
    <label *ngIf="showText" class="mb-0 cursor-pointer" for="customSwitches{{sequence}}">
        <span class="ml-5 eod-text-secondary fw-600 f-14 text-nowrap">{{ showSwitchText }}</span>
    </label>
</div>